
















































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import Datepicker from 'vue2-datepicker';
import i18n from '@/services/i18n';
import i18nDb from '@/services/i18n-db';
import * as common from '../common';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Utils } from '../types';


type SortField = 'ID' | 'CODE' | 'RANK' | 'RATE' | 'BEG_DATE' | 'END_DATE' | 'CUR_YEAR' | 'RATE_REMAINDER';

/**
 * Настройки поиска поправочных коэффициентов рабочих должностей
 */
interface DictWorkPositionRankSearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Список ID записей
     */
    idSet: Array<number> | null;

    /**
     * Список значений: Код
     */
    codeSet: Array<string> | null;

    /**
     * Стартовое значение: Квалификационный разряд
     */
    rankStartValue: number | null;

    /**
     * Конечное значение: Квалификационный разряд
     */
    rankEndValue: number | null;

    /**
     * Стартовое значение: Коэффициент к БДО
     */
    rateStartValue: number | null;

    /**
     * Стартовое значение: Коэффициент к БДО
     */
    rateEndValue: number | null;

    /**
     * Стартовое значение: Дата начала действия
     */
    begDateStartValue: Date | null;

    /**
     * Конечное значение: Дата начала действия
     */
    begDateEndValue: Date | null;

    /**
     * Стартовое значение: Дата окончания действия
     */
    endDateStartValue: Date | null;

    /**
     * Конечное значение: Дата окончания действия
     */
    endDateEndValue: Date | null;

    curYearStartValue: number | null;
    curYearEndValue: number | null;
    rateRemainderStartValue: number | null;
    rateRemainderEndValue: number | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        id: {
            get title(): string {
                return 'ID';
            },
        },
        code: {
            get title(): string {
                return i18n.choose(
                    'Код',
                    'Код',
                    'Code',
                );
            },
        },
        rank: {
            get title(): string {
                return i18n.choose(
                    'Квалификационный разряд',
                    'Біліктілік санаты',
                    'Qualification category',
                );
            },
        },
        rate: {
            get title(): string {
                return i18n.choose(
                    'Коэффициент к БДО',
                    'НЛЖ коэффициенті',
                    'Coefficient to BOS',
                );
            },
        },
        begDate: {
            get title(): string {
                return i18n.choose(
                    'Дата начала действия',
                    'Күшіне ену күні',
                    'Effective Date',
                );
            },
        },
        endDate: {
            get title(): string {
                return i18n.choose(
                    'Дата окончания действия',
                    'Мерзімнің өту күні',
                    'Expiration date',
                );
            },
        },
        curYear: {
            get title(): string {
                return i18n.choose(
                    'Базовый год',
                    'Негізгі жыл',
                    'Base year',
                );
            },
        },
        rateRemainder: {
            get title(): string {
                return i18n.choose(
                    'Остаток коэффициента',
                    'Коэффициенттің қалдығы',
                    'Remainder of the coefficient',
                );
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictWorkPositionRankSearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        codeSet: null,
        rankStartValue: null,
        rankEndValue: null,
        rateStartValue: null,
        rateEndValue: null,
        begDateStartValue: null,
        begDateEndValue: null,
        endDateStartValue: null,
        endDateEndValue: null,
        curYearStartValue: null,
        curYearEndValue: null,
        rateRemainderStartValue: null,
        rateRemainderEndValue: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        'date-picker': Datepicker,
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictWorkPositionRankListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private formatDate(value: Date | null): string | null {
        if (value === null) {
            return null;
        }
        return i18nDb.translateByTemplate(i18nDb.dateTemplateLong(), value);
    }

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // CODE
            {
                value: 'CODE',
                text: translates.fields.code.title,
            },

            // RANK
            {
                value: 'RANK',
                text: translates.fields.rank.title,
            },

            // RATE
            {
                value: 'RATE',
                text: translates.fields.rate.title,
            },

            // BEG_DATE
            {
                value: 'BEG_DATE',
                text: translates.fields.begDate.title,
            },

            // END_DATE
            {
                value: 'END_DATE',
                text: translates.fields.endDate.title,
            },

            // CUR_YEAR
            {
                value: 'CUR_YEAR',
                text: translates.fields.curYear.title,
            },

            // RATE_REMAINDER
            {
                value: 'RATE_REMAINDER',
                text: translates.fields.rateRemainder.title,
            },
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.WorkPositionRank> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterCodeSet: Set<string> = new Set();
    private filterCodeSetInput: string = '';
    private filterRankStartValue: number | null = null;
    private filterRankStartValueInput: number | null = null;
    private filterRankEndValue: number | null = null;
    private filterRankEndValueInput: number | null = null;
    private filterRateStartValue: number | null = null;
    private filterRateStartValueInput: number | null = null;
    private filterRateEndValue: number | null = null;
    private filterRateEndValueInput: number | null = null;
    private filterBegDateStartValue: Date | null = null;
    private filterBegDateStartValueInput: Date | null = null;
    private filterBegDateEndValue: Date | null = null;
    private filterBegDateEndValueInput: Date | null = null;
    private filterEndDateStartValue: Date | null = null;
    private filterEndDateStartValueInput: Date | null = null;
    private filterEndDateEndValue: Date | null = null;
    private filterEndDateEndValueInput: Date | null = null;
    private filterCurYearStartValue: number | null = null;
    private filterCurYearStartValueInput: number | null = null;
    private filterCurYearEndValue: number | null = null;
    private filterCurYearEndValueInput: number | null = null;
    private filterRateRemainderStartValue: number | null = null;
    private filterRateRemainderStartValueInput: number | null = null;
    private filterRateRemainderEndValue: number | null = null;
    private filterRateRemainderEndValueInput: number | null = null;

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }

    private get filterCodeSetParsed(): Array<string> {
        return this.filterCodeSetInput
            .split(',')
            .map(value => value.trim())
            .filter(value => (value.length > 0));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterCodeSetInput = [...this.filterCodeSet].join(', ');
        this.filterRankStartValueInput = this.filterRankStartValue;
        this.filterRankEndValueInput = this.filterRankEndValue;
        this.filterRateStartValueInput = this.filterRateStartValue;
        this.filterRateEndValueInput = this.filterRateEndValue;
        this.filterBegDateStartValueInput = this.filterBegDateStartValue;
        this.filterBegDateEndValueInput = this.filterBegDateEndValue;
        this.filterEndDateStartValueInput = this.filterEndDateStartValue;
        this.filterEndDateEndValueInput = this.filterEndDateEndValue;
        this.filterCurYearStartValueInput = this.filterCurYearStartValue;
        this.filterCurYearEndValueInput = this.filterCurYearEndValue;
        this.filterRateRemainderStartValueInput = this.filterRateRemainderStartValue;
        this.filterRateRemainderEndValueInput = this.filterRateRemainderEndValue;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterCodeSetInput = '';
        this.filterRankStartValueInput = null;
        this.filterRankEndValueInput = null;
        this.filterRateStartValueInput = null;
        this.filterRateEndValueInput = null;
        this.filterBegDateStartValueInput = null;
        this.filterBegDateEndValueInput = null;
        this.filterEndDateStartValueInput = null;
        this.filterEndDateEndValueInput = null;
        this.filterCurYearStartValueInput = null;
        this.filterCurYearEndValueInput = null;
        this.filterRateRemainderStartValueInput = null;
        this.filterRateRemainderEndValueInput = null;
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterCodeSet = new Set(this.filterCodeSetParsed);
        this.filterRankStartValue = this.filterRankStartValueInput;
        this.filterRankEndValue = this.filterRankEndValueInput;
        this.filterRateStartValue = this.filterRateStartValueInput;
        this.filterRateEndValue = this.filterRateEndValueInput;
        this.filterBegDateStartValue = this.filterBegDateStartValueInput;
        this.filterBegDateEndValue = this.filterBegDateEndValueInput;
        this.filterEndDateStartValue = this.filterEndDateStartValueInput;
        this.filterEndDateEndValue = this.filterEndDateEndValueInput;
        this.filterCurYearStartValue = this.filterCurYearStartValueInput;
        this.filterCurYearEndValue = this.filterCurYearEndValueInput;
        this.filterRateRemainderStartValue = this.filterRateRemainderStartValueInput;
        this.filterRateRemainderEndValue = this.filterRateRemainderEndValueInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterCodeSet.size > 0) {
            searchConfig.codeSet = [...this.filterCodeSet];
        }
        if (this.filterRankStartValue != null) {
            searchConfig.rankStartValue = this.filterRankStartValue;
        }
        if (this.filterRankEndValue != null) {
            searchConfig.rankEndValue = this.filterRankEndValue;
        }
        if (this.filterRateStartValue != null) {
            searchConfig.rateStartValue = this.filterRateStartValue;
        }
        if (this.filterRateEndValue != null) {
            searchConfig.rateEndValue = this.filterRateEndValue;
        }
        if (this.filterBegDateStartValue != null) {
            searchConfig.begDateStartValue = common.convertToKotlinLocalDate(this.filterBegDateStartValue) as unknown as Date;
        }
        if (this.filterBegDateEndValue != null) {
            searchConfig.begDateEndValue = common.convertToKotlinLocalDate(this.filterBegDateEndValue) as unknown as Date;
        }
        if (this.filterEndDateStartValue != null) {
            searchConfig.endDateStartValue = common.convertToKotlinLocalDate(this.filterEndDateStartValue) as unknown as Date;
        }
        if (this.filterEndDateEndValue != null) {
            searchConfig.endDateEndValue = common.convertToKotlinLocalDate(this.filterEndDateEndValue) as unknown as Date;
        }
        if (this.filterCurYearStartValue != null) {
            searchConfig.curYearStartValue = this.filterCurYearStartValue;
        }
        if (this.filterCurYearEndValue != null) {
            searchConfig.curYearEndValue = this.filterCurYearEndValue;
        }
        if (this.filterRateRemainderStartValue != null) {
            searchConfig.rateRemainderStartValue = this.filterRateRemainderStartValue;
        }
        if (this.filterRateRemainderEndValue != null) {
            searchConfig.rateRemainderEndValue = this.filterRateRemainderEndValue;
        }

        const loadingId = Symbol('DictWorkPositionRankListPage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.WorkPositionRank>>(
            {
                url: '/api/budget/staffing_table/dict/dict_work_position_rank/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                data.items.forEach((item) => {
                    if (Array.isArray(item.begDate)) {
                        item.begDate = common.convertFromKotlinLocalDate(item.begDate);
                    }
                    if (Array.isArray(item.endDate)) {
                        item.endDate = common.convertFromKotlinLocalDate(item.endDate);
                    }
                });

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID записи
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * Код
     */
    private changedElementCode: string = '';

    /**
     * Квалификационный разряд (число от 1 до 8)
     */
    private changedElementRank: number = 0;

    /**
     * Размер поправочного коэффициента к должностному окладу
     */
    private changedElementRate: number = 0;

    /**
     * Дата начала действия (включительно)
     */
    private changedElementBegDate: Date | null = null;

    /**
     * Дата окончания действия (не включительно)
     */
    private changedElementEndDate: Date | null = null;

    private changedElementCurYear: number | null = null;

    /**
     * Остаток от поправочного коэффициента.
     *
     * Для распределения по двум бюдж. программам.
     */
    private changedElementRateRemainder: number | null = null;

    private startElementChange(element?: Dict.WorkPositionRank) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementCode = '';
            this.changedElementRank = 0;
            this.changedElementRate = 0;
            this.changedElementBegDate = null;
            this.changedElementEndDate = null;
            this.changedElementCurYear = null;
            this.changedElementRateRemainder = null;
        } else {
            this.changedElementId = element.id;
            this.changedElementCode = element.code;
            this.changedElementRank = element.rank;
            this.changedElementRate = element.rate;
            this.changedElementBegDate = element.begDate;
            this.changedElementEndDate = element.endDate;
            this.changedElementCurYear = element.curYear;
            this.changedElementRateRemainder = element.rateRemainder;
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const data: Dict.WorkPositionRank = {
            id: this.changedElementId,
            code: this.changedElementCode,
            rank: this.changedElementRank,
            rate: this.changedElementRate,
            begDate: this.changedElementBegDate,
            endDate: this.changedElementEndDate,
            curYear: this.changedElementCurYear,
            rateRemainder: this.changedElementRateRemainder,
        };
        if (data.begDate !== null) {
            data.begDate = (common.convertToKotlinLocalDate(data.begDate) as unknown as Date);
        }
        if (data.endDate !== null) {
            data.endDate = (common.convertToKotlinLocalDate(data.endDate) as unknown as Date);
        }


        const loadingId = Symbol('DictWorkPositionRankListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_work_position_rank',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.WorkPositionRank) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictWorkPositionRankListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_work_position_rank',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
